<template>
    <div class="c-field">
        <label>{{text}}</label>

        <div class="c-select">
            <select v-model="period" @change="onChange">
                <option
                    v-for="(option, index) in options"
                    :key="index"
                    :value="option.value"
                    :selected="index === 0"
                >{{option.label}}</option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                period: 52,
                options: [
                    {
                        label: "Per Week",
                        value: 52
                    },
                    {
                        label: "Per Month",
                        value: 12
                    },
                    {
                        label: "Per Year",
                        value: 1
                    }
                ]
            };
        },

        props: {
            text: {
                type: String,
                required: false
            },

            initialValue: {
                type: Number,
                required: false
            }
        },

        methods: {
            onChange() {
                this.$emit("changed", this.period);
            }
        },

        created() {
            if (typeof this.initialValue !== "undefined") {
                this.period = this.initialValue;
            }
        }
    };
</script>

<style lang="scss">
    .c-select {
        min-width: 12.375rem;
        position: relative;

        select {
            border: none;
            background-color: #fdfdfd;
            font-size: 1rem;
            font-weight: 500;
            line-height: 1.2;
            appearance: none;
            padding-top: 0.6875rem;
            padding-left: 0.6875rem;
            width: 100%;

            &:focus {
                outline: none;
            }
        }

        &::after {
            content: "";
            width: 0.37rem;
            height: 0.37rem;
            display: block;
            position: absolute;
            top: 0.5rem;
            right: 1.312rem;
            bottom: 0;
            margin: auto;
            border-width: 0 0 1px 1px;
            border-style: solid;
            border-color: #000;
            transform: rotate(-45deg);
        }

        @media screen and (max-width: 1024px) {
            select {
                padding-bottom: 0.625rem;
            }
        }
    }
</style>
